module.exports = "https://dashboard.cdn.gifty.nl/6091/images/timer-white.png?1784da3519c3118cfd2ac85aaae94bd7";